export default __webpack_public_path__ + "static/media/29.b07f722f.jpg";